import { IImage } from "@app/api/core/image";
import { UspModule } from "@app/api/core/usp";
import { BottomFooter } from "@app/api/modules/footer/models/bottom-footer";
import { MiddleFooter } from "@app/api/modules/footer/models/middle-footer";

import { unitedKingdomPlatform } from "./platforms/united-kingdom";
import { landingPagePlatform } from "./platforms/landing-page";
import { belgiumNLPlatform } from "./platforms/belgium-nl";
import { netherlandsPlatform } from "./platforms/dutch";
import { belgiumFRPlatform } from "./platforms/belgium-fr";
import { francePlatform } from "./platforms/france";
import { germanyPlatform } from "./platforms/germany";
import { swedenPlatform } from "./platforms/sweden";
import { spainPlatform } from "./platforms/spain";
import { italyPlatform } from "./platforms/italy";

interface ITabLink {
  href: string;
  isSelected?: boolean;
  title: string;
}

export enum PlatformType {
  NETHERLANDS = 1,
  BELGIANDUTCH = 2,
  BELGIANFRENCH = 3,
  FRENCH = 4,
  LANDINGPAGE = 8,
  UNITED_KINGDOM = 9,
  GERMANY = 10,
  SWEDEN = 11,
  SPAIN = 12,
  ITALY = 13
}

export const platforms: IPlatformSpecificInfo[] = [
  landingPagePlatform,
  netherlandsPlatform,
  belgiumNLPlatform,
  belgiumFRPlatform,
  francePlatform,
  unitedKingdomPlatform,
  germanyPlatform,
  swedenPlatform,
  spainPlatform,
  italyPlatform
];

// All four live platforms — client decision 2026-08-04 (Jira BF-5068), overriding spec §7's NL-only launch.
export const PRODUCT_COMPARISON_LINK_PLATFORMS: PlatformType[] = [
  PlatformType.NETHERLANDS,
  PlatformType.BELGIANDUTCH,
  PlatformType.BELGIANFRENCH,
  PlatformType.GERMANY
];

export interface IPlatformSpecificInfo {
  id: number;
  domain: string;
  abbreviation: string;
  url?: string;
  merchantOverviewLink: string;
  dealOverviewLink: string;
  urlAddition: string;
  isLandingPage?: boolean;
  defaultBackButtonText: string;
  breadcrumbHomeName: string;
  breadcrumbHomeUrl: string;
  readingTimeText: {
    singular: string;
    plural: string;
  };
  newsletterButtonTitle: string;
  newsletterModalTitle: string;
  fallBackHeaderImage: string;
  bottomFooter: BottomFooter;
  middleFooter: MiddleFooter;
  fallbackMerchantHeader: IImage;
  logo: IImage;
  uspModule: UspModule;
  storeTabs: ITabLink[];
  dealTabs: ITabLink[];
  locale: string;
  /** WCT V1 loader; platforms on WCT V2 load their tag in the head instead (src/server/helpers/wecantrack.ts). */
  weCanTrackScriptLocation?: string;
  tagManagerScriptLocation: string;
  favIcon: string;
  favIconPublic: string;
  gtm: string;
  currency: string;
  name: string;
  country: string;
  enableDealAlerts: boolean;
  isOffline: boolean;
}
